import ApiService from './ApiService'

export default class VodService {
    apiService

    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_VOD_API)
    }

    async get({ uvid, cc, lang, key }) {
        const request = await this.apiService
            .get(`/${ uvid }`, { key, cc, lang })

        return request.data
    }
}
